export enum TagManagerPageViewEnum {
    COMO_QUIERES_VENDER = '/mdcp/como-quieres-vender',
    DATOS_PERSONALES = '/mdcp/checkout/datos-personales',
    DATOS_COMERCIO ='/mdcp/checkout/datos-comercio',
    CONF_DE_TU_PRODUCTO='/mdcp/checkout/configuracion-producto',
    ADJ_DOCUMENTOS='/mdcp/checkout/adjuntar-documento',
    CTA_BCARIA_ABONO='/mdcp/checkout/cuenta-bancaria',
    DET_CONTRATACION_Y_CONFIRMA = '/mdcp/checkout/detalles-contratacion-confirma',
    CONFIRMA_COMPRA='/mdcp/confirmacion-solicitud',
    RESUMEN_COMPRA='/mdcp/resumen-compra',
    NO_INICIO_ACTIVIDADES='NO_INICIO_ACTIVIDADES',
    SOLICITUD_EXITOSA='SOLICITUD_EXITOSA'
}

